import React from 'react';
import { observer } from 'mobx-react-lite';
import { IMInputText } from '@insurancemenu/imenu-components-lib';
import { useAccountSettingsPageStore } from 'store/pages/user-settings/account-settings/pageStore';
import SectionTitle from 'components/common/general/SectionTitle';
import { IMFormStyled, IMInputTextStyled } from './styles';
import { ACCOUNT_SETTINGS_FORM_ID } from './constants';

const AccountSettingsForm: React.FC = observer(() => {
  const { accountSettingsForm } = useAccountSettingsPageStore();

  return (
    <>
      <IMFormStyled id={ACCOUNT_SETTINGS_FORM_ID} formController={accountSettingsForm}>
        <SectionTitle title="Personal Information" />
        <IMInputTextStyled label="First Name" name="firstName" size="m" />
        <IMInputTextStyled label="Last Name" name="lastName" size="m" />
        <IMInputText label="Email" name="email" size="full" disabled />
      </IMFormStyled>
    </>
  );
});

export default AccountSettingsForm;
